export const getters = {
  prixs (state) {
    return state.prixs
  },
  prix (state) {
    return state.prix
  },  
  pagination(state){
    return state.pagination
  }
}
